export const API_LIQUI_CREATE = '/tao-bao-cao-kiem-ke'
export const API_LIQUI_CREATE2 = '/tao-phieu-kiem-ke'
export const API_LIQUI_LST = '/danh-sach-bao-cao-kiem-ke'
export const LINK_TUTORIAL = 'https://drive.google.com/file/d/1m3Px7Nn3G9Ma_E0lnX7tfh3_bWV2pQU6/view?usp=sharing'
export const LINK_DOCUMENT = 'https://thuvienphapluat.vn/van-ban/Doanh-nghiep/Thong-tu-45-2018-TT-BTC-huong-dan-tinh-hao-mon-khau-hao-tai-san-co-dinh-tai-co-quan-nha-nuoc-370741.aspx'